import React, { Fragment, useContext, useEffect, useState, useRef } from 'react';
import propTypes from 'prop-types';
import { Button, Image } from 'react-bootstrap';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import Layout from 'components/sales/layout/layout';
import GSTDetails from 'components/sales/formSection/GSTDetails/gstDetails';
import ParkingRules from 'components/sales/formSection/parkingRules/parkingRules';
import MaterialHardware from 'components/sales/formSection/materialHardware/materialHardware';
import Tags from 'components/sales/formSection/materialHardware/tags';
import AdvancePaymentNew from 'components/sales/formSection/materialHardware/advancePaymentNew';
import Increament from 'components/sales/formSection/materialHardware/increament';
import ThreePOC from 'components/sales/formSection/materialHardware/threePoc';
import ShippedTo from 'components/sales/formSection/shippedTo/shippedTo';
import BilledTo from 'components/sales/formSection/billedTo/billedTo';
import OtherDetails from 'components/sales/formSection/otherDetails/otherDetails';
import GateDetails from 'components/sales/formSection/gateDetails/gateDetailsApt';
import GateDetailsNew from 'components/sales/formSection/gateDetails/gateDetailsNew';
import CommercialNew from 'components/sales/formSection/commercial/commercialNew';
import Installation from 'components/sales/formSection/commercial/installation';
import Milestone from 'components/sales/formSection/mileStone/mileStoneNew';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { handleValidateObj } from 'constants/objValues/objvalues';
import { Link } from 'react-router-dom';
import AgreementContractNew from 'components/sales/formSection/agreementContract/agreementContractNew';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import ClientAddressDetailsV2 from 'components/sales/formSection/clientDetails/clientAddressDetailsV2';
import InvoiceModule from 'components/sales/formSection/materialHardware/invoiceModule';
import AddPoc from "../../../../components/sales/formSection/addPoc/addPoc";
import {getContractRevenue} from "../../../../services/redux/sales/postSales/action";
import B2BRevenue from "../B2BRevenue";
import ContractServices from "../ContractServices";
import "./progress.css";
import Regex from 'services/utils/regex/Regex';
import InvoiceModuleCapex from 'components/sales/formSection/materialHardware/InvoiceModuleCapex';
import {
  invoiceValidator
} from "../../../../services/utils/helpers/invoiceValidators";

const PostSalesCorporateV2Edit = (props) => {
  const {
    history,
    postCorporate,
    postCorData,
    pincodeData,
    locationPinCode,
    postSalesInstallation,
    postSalesMileStone,
    postSalesInvoiceModule,
    postSalesCorporateLeadNew,
    postSolutionProduct,
    getMaterial,
    getTag,
    getTagById,
    getMateriaById,
    documentUploadUrl,
    documentUrlData,
    imageUploadUrl,
    videoUploadUrl,
    match,
    supplyNameFun,
    splNameData,
    shipTolocationPinCode,
    shipToPincodeData,
    clientBillingPocData,
    clientBillingAddress,
    getContractRevenue,
    contractRevenueDetails=[],
    getContractService,
    contractCatService=[],
    postSalesClientData,
    getBrandById,
    getBrand,
    postSalesAdvancePayments,
    getSalesCorporateLeadNew,
    postSalesData=[],
    revenueNature,
    getRevenueNature,
    managementFeeApplicable,
    checkManagementFeeApplicable,
    userRoleBasedDropdown,
    getUserBasedDropdown=[],
    saveExternalUserData,
    insertExternalUser=[],
    getInventoryMasterData,
    inventoryData,
    getRequiredDocumentsDropdown,
    requiredDocumentsDropdown = [],
    documentUploadUrlPublic,
    documentUrlDataPublic=[],
    postCapexInvoiceModule,
    contractInvoicePreview
  } = props;
  const { params } = match;
  const postDataInputs = {
    commercial: null,
    gSTDetails: null,
    parkingRules: null,
    shippedTo: null,
    // billedTo: null,
    clientData: null,
    installation: null,
    payment:[],
    otherDetails: null,
    gateDetails: null,
    tags:[],
    category: [],
    materialHardwares: 'No',
    gates: null,
    agreementDtls: null,
    InvoiceModuleData:null,
    pocData: null,
    revenue_nature: 'Self',
    revenue_type:'Fixed',
    invoice_type:'Post',
    softwareInventory: null
  };
  // console.log('Hi, Nice Work.. We are on edit mode.');
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [sameAsBillTo, setSameAsBillTo] = useState(null);
  const [showAgreementDetails, setShowAgreementDetails] = useState(false);
  const [agreementLength, setAgreementLength] = useState(null);
  const [isGateDetailsChanged, setIsGateDetailsChanged] = useState(false);
  const [postCorporateData, setPostCorporateData] = useState(postDataInputs);
  const [variableServices, setVariableServices] = useState([
    { id: "", amount: "", qty: "", men_days: 0, start_day: "", end_day: "", management_fee_applicable: 0 },
  ]);
  const [fixedServices, setFixedServices] = useState([
    { id: "", amount: "", qty: "", men_days: 0, management_fee_applicable: 0 },
  ]);
  
  const [projectName, setProjectName] = useState("");
  const [formStage, setFormStage] = useState("");
  const [selectedFormStage, setSelectedFormStage]=useState(0);
  const [disabled, setDisabled ]= useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [leadTypeId, setLeadTypeId] = useState(null);
  const [postCorporateDetails, setPostCorporateDetails] = useState(null);
  const [inventoryMasterData, setInventoryMasterData] = useState([]);
  const [inventoryEditable, setInventoryEditable] = useState(true);
  const [isEcom, setIsEcom] = useState(false);

  const [capexInvoiceLink, setCapexInvoiceLink] = useState([]);

  const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]$/i;

  useEffect(() => {
    if(params?.lead_id) {
    (async () => {
      // await getRevenueNature(params.lead_id);
      if(postCorData?.commercialData?.solution_type === 3){
        await checkManagementFeeApplicable(params.lead_id);  
      }
    })();
  }
  }, []);

  useEffect(() => {
    (async () => {
      let currentFormStage = formStage !== null ? formStage : postCorData?.commercialData?.form_stage;
      if(currentFormStage === 3){
        await getRequiredDocumentsDropdown();
      }
    })()
  }, [getRequiredDocumentsDropdown, formStage]);

  useEffect(() => {
    if(postCorData && postCorData !== undefined) {
      setPostCorporateDetails(postCorData);
    }
    if (postCorData && postCorData?.lead_name !== undefined) {
      setProjectName(postCorData?.lead_name);
    }
    if(postCorData && postCorData?.leadType !== undefined) {
      setLeadTypeId(postCorData?.leadType);
    }
    if(postCorData && postCorData?.commercialData !== undefined && postCorData?.commercialData?.form_stage !== undefined) {
      setFormStage(postCorData?.commercialData.form_stage);
      setSelectedFormStage(postCorData?.commercialData.form_stage);
    } else {
      setFormStage(1);
      setSelectedFormStage(1)
    }
  },[postCorData]); 

  useEffect(() => {
     if(match.params.lead_id!=undefined  && match.params.lead_id!=null && match.params.lead_id!='' && match.params.comm_id != '')
      (async()=>{
          // if(postCorData && postCorData?.commercialData && postCorData?.commercialData?.form_stage>1){
            await getSalesCorporateLeadNew(match.params.comm_id);
          // }
      })();
  }, [formStage]);
  const handleGoBack = (val) => {
    if(formStage>1){
      if (postCorData?.commercialData?.solution_type == 3 && formStage == 6) {
        setFormStage(formStage-2);
      } else {
        setFormStage(formStage-1);  
      }
    }
  };

  useEffect(() => {
      setDisabled(true);
      if (postSalesData?.material_hardware?.prod_array != null && postSalesData?.material_hardware?.prod_array !== undefined && postSalesData?.material_hardware?.prod_array.length > 0 ) {
        setInventoryEditable(false)
      }
      setTimeout(() => {
        setDisabled(false);
      }, 1000);
  }, [postSalesData]);

  useEffect(() => {
    if (
      (postCorporateData?.softwareInventory === null ||
        postCorporateData?.softwareInventory === undefined) &&
      Array.isArray(postSalesData?.software) &&
      postSalesData.software.length > 0
    ) {
      setPostCorporateData((prev) => ({
        ...prev,
        softwareInventory: { softwareInventoryData: postSalesData.software },
      }));
    }
  }, [postSalesData?.software, postCorporateData?.softwareInventory]);

  const handleCommercial = (val) => {
    setPostCorporateData({ ...postCorporateData, commercial: val });
    if(val?.solution_type && val?.solution_type == 99){
      setIsEcom(true);
    }
    else{
      setIsEcom(false);
    }
    if (val?.totalContract) {
      setShowAgreementDetails(true);
      setAgreementLength(val?.totalContract);
    }
  };
  const handleCapexInvoiceModule = (val) => {
    setPostCorporateData({ ...postCorporateData, capexInvoiceModule: val });
  };
  const handleGstDetails = (val) => {
    setPostCorporateData({ ...postCorporateData, gSTDetails: val });
  };
  const handleParkingRules = (val) => {
    setPostCorporateData({ ...postCorporateData, parkingRules: val });
  };
  const handleGateDtl = (val) => {
    setPostCorporateData({ ...postCorporateData, gateDetails: val });
    setIsGateDetailsChanged(true);
  };
  const handleMileStone = (val) => {
    setPostCorporateData({ ...postCorporateData, milestone: val });
  };
  // const handleBillTo = (val) => {
  //   setPostCorporateData({ ...postCorporateData, billedTo: val });
  // };
  const handleClientData = (val) => {
    setPostCorporateData({ ...postCorporateData, clientData: val });
  };
  const handlePocData = (val) => {
    setPostCorporateData({ ...postCorporateData, pocData: val });
  };
  const handleInstallation = (val) => {
    setPostCorporateData({ ...postCorporateData, installation: val });
  };
  const handlePayment = (val) => {
    setPostCorporateData({ ...postCorporateData, advPayment: val });
  };

  const handleIncreament = (val) => {
    setPostCorporateData({ ...postCorporateData, increamentData: val });
  };
  const handleThreePoc = (val) => {
    setPostCorporateData({ ...postCorporateData, pocData: val });
  };
  
  
  const handleShippedTo = (val) => {
    setPostCorporateData({ ...postCorporateData, shippedTo: val });
  };
  const handleOtherDetails = (val) => {
    setPostCorporateData({ ...postCorporateData, otherDetails: val });
  };
  const handleGatesData = (val) => {
    setPostCorporateData({ ...postCorporateData, categoryInventory: val });
  };
  const handleProductData = (val) => {
    setPostCorporateData({ ...postCorporateData, productInventory: val });
  };
  const handleMaterialhardware = (val) => {
    postCorporateData['materialHardwares'] = val
    setPostCorporateData({...postCorporateData, materialHardwares: val}); 
  }

  const handleTags = (val) => {
    setPostCorporateData({ ...postCorporateData, tagsData: val });
  };

  const handleagreementDtls = (val) => {
    setPostCorporateData({ ...postCorporateData, agreementDtls: val });
  };
  const handleInvoiceAmt = (val) => {
    setPostCorporateData({ ...postCorporateData, InvoiceModuleData: val });
  }; 

  const handleModalHide = () => {
    history.push(`${baseUrl}/postSalesListing`);
    setIsModal(false);
  };


  const handleRevenueDetails = (key, value) => {
    postCorporateData[key] = value
    setPostCorporateData(postCorporateData);
  }

  const handleRequiredValues = (val) => {
    setPostCorporateData({ ...postCorporateData, selectedDocuments: val });
  };

  const handleSoftwareInventory = (val) => {
    setPostCorporateData({ ...postCorporateData, softwareInventory: val });
  };

  const handleSubmit = (id) => {
    setIsClicked(true);
    // console.log('1' + postCorporateData?.shippedTo);
    const {
      commercial,
      gSTDetails,
      // parkingRules,
      gateDetails,
      installation,
      // billedTo,
      shippedTo,
      clientData,
      // otherDetails,
      categoryInventory,
      productInventory,
      materialHardwares,
      tagsData,
      advPayment,
      increamentData,
      agreementDtls,
      milestone,
      InvoiceModuleData,
      // pocData
      revenue_nature,
      revenue_type,
      invoice_type,
      selectedDocuments
    } = postCorporateData;
    if(postCorData.leadStatus !== 9 && (postCorData?.commercialData?.revenue_nature === null || postCorData?.commercialData?.revenue_nature === '')){
      toast.warning("Please contract revenue nature")
      return false
    }

    if (
      (postCorData.leadStatus <= 4 &&
      (commercial != null &&
        // billedTo != null &&
        clientData !== null &&
        shippedTo != null &&
        agreementDtls != null &&
        gSTDetails != null
        // && pocData !== null
      )
      ) || (postCorData.leadStatus === 9 && postCorData?.commercialData?.revenue_nature !== 'Valet' && (gateDetails != null))
      ||
      (postCorData.leadStatus === 9 && (
        // otherDetails != null &&
        gateDetails != null &&
        materialHardwares != null
      ))  
       
    ) {
      setIsClicked(false);
      setIsFiled(false);

      if(clientData != null && clientData.billing_address !== undefined){
        var fObj = {
          ...commercial,
          ...installation,
          ...gSTDetails,
          // ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          // ...otherDetails,
          ...agreementDtls,
          clientData: clientData,
          gateDetails: gateDetails,
          leadStatus:postCorData.leadStatus,
          comm_id:match.params.comm_id,
          isNewContract:1,
          materialHardwares: { ...materialHardwares },
          ...clientData.billing_address,
          selectedDocuments: { ...selectedDocuments}
          // pocData: pocData
        };
      } else {
        var fObj = {
          ...commercial,
          ...installation,
          ...gSTDetails,
          // ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          // ...otherDetails,
          ...agreementDtls,
          clientData: clientData,
          gateDetails: gateDetails,
          comm_id:match.params.comm_id,
          isNewContract:1,
          leadStatus:postCorData.leadStatus,
          materialHardwares: { ...materialHardwares },
          selectedDocuments: { ...selectedDocuments}
          // pocData: pocData,
          // ...clientData.billing_address
        };
      }
      // if (categoryInventory !== null && categoryInventory !== undefined) {
      //   fObj.categoryInventory = [
      //     ...categoryInventory,
      //     ...productInventory?.productData,
      //   ];
      // } else {
      //   fObj.categoryInventory = [];
      // }
      if (categoryInventory !== null && categoryInventory !== undefined && productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
          ...productInventory?.productData,
        ];
      } else if (categoryInventory !== null && categoryInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
        ];
      } else if (productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...productInventory?.productData,
        ];
      } else {
        fObj.categoryInventory = [];
      }

      if (tagsData !== null && tagsData !== undefined) {
        fObj.tags = [
          ...tagsData?.tagData,
        ];
      } else {
        fObj.tags = [];
      }

      if (advPayment !== null && advPayment !== undefined) {
        fObj.payment = [
          ...advPayment?.advData,
        ];
      } else {
        fObj.payment = [];
      }
      if (increamentData !== null && increamentData !== undefined) {
        if (increamentData?.inc?.increament_type) {
          if (increamentData?.inc?.increament_type == 'flat' || increamentData?.inc?.increament_type == 'percentage') {
            if (increamentData?.inc?.duration == undefined || increamentData?.inc?.increament_amount == undefined) {
              return false;
            }
          }
          fObj.increament = [
            increamentData
          ];
        } else {
          fObj.increament = [];
        }
      } else {
        fObj.increament = [];
      }
      if (milestone !== null && milestone != undefined) {
        let totalAmt = parseInt(postCorData?.commercialData?.total_mg_amount);
        let calculatedAmt = 0;
        if (!isNaN(totalAmt)) {
          if (totalAmt > 0) {
            for (let i = 0; i < postCorporateData.milestone?.milestone_data.length; i++) {
              if (postCorporateData.milestone.milestone_data[i].amt) {
                calculatedAmt += parseInt(postCorporateData.milestone.milestone_data[i].amt);
              }
            }
            for (let i = 0; i < postCorporateData.milestone?.date_invoices_data.length; i++) {
              if (postCorporateData.milestone.date_invoices_data[i].amt) {
                calculatedAmt += parseInt(postCorporateData.milestone.date_invoices_data[i].amt);
              }
            }
            for (let i = 0; i < postCorporateData.milestone?.retention.length; i++) {
              if (postCorporateData.milestone.retention[i].amt) {
                calculatedAmt += parseInt(postCorporateData.milestone.retention[i].amt);
              }
            }
            if (calculatedAmt > totalAmt) {
              toast.error('Milestone total amount is greater then capex amount!');
              setIsClicked(false);
              setIsFiled(true);
              return;
            } else {
              fObj.milestone=milestone;
            }
          }
        }
      }

      fObj['revenue_nature'] = postCorData?.commercialData?.revenue_nature
      fObj['revenue_type'] = revenue_type
      fObj['invoice_type'] = invoice_type

      if(postCorData?.commercialData !== undefined && postCorData?.commercialData?.revenue_nature === 'Valet'){
        fObj['variable_services'] = variableServices
        fObj['fixed_services'] = fixedServices
      }else{
          fObj['invoice_type'] = 'Pre'
          fObj['revenue_type'] = 'Fixed'
      }

      if(InvoiceModuleData !== null && InvoiceModuleData != undefined){
        let subsAmt = Number(postCorData?.commercialData?.subscription_amount);
        let invoiceAmt = InvoiceModuleData?.invoiceAmt;
        const initialValue = 0;
        const sumWithInitial = invoiceAmt.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
        );
        // console.log(sumWithInitial);
        if(subsAmt === sumWithInitial ){
          fObj.InvoiceModuleData=InvoiceModuleData;
        }else{
          toast.error('Total amount of invoice module is not equal to the total subscription amount!');
          setIsClicked(false);
          setIsFiled(true);
          return;
        }
       

      }
      
      (async () => {
        const res = await postSalesCorporateLeadNew({ ...fObj, leadId: id });
        if (res) {
          setIsModal(true);
        }
      })();
      
    } else {

      setIsClicked(false);
      setIsFiled(true);
      const active = document.querySelector('.activeAnkInput');
      // console.log(active);
      if(active){

        active.focus();
      }else{
        alert('Please Upload missed documents or enter valid data!')
      }
    }
  };

  useEffect(() => {
    (async () => {
      // Pass comm_id so valet_contract_* services are loaded for this contract
      // (without it the API falls back to lead-level rows with comm_id IS NULL).
      await postCorporate(params.lead_id, params.comm_id);
    })();
  }, [params.lead_id, params.comm_id]);
  
  useEffect(() => {
    if (postCorData?.commercialData?.solution_type === 3) {
      (async () => {
        await getContractRevenue();
        await getContractService('VALET');
      })();
    }
  }, [postCorData]);

  // Prefill Variable/Fixed Services on edit (same as editCorpContract / editAptContract).
  useEffect(() => {
    if (
      postCorData?.valet_contract_variable_service !== undefined &&
      postCorData?.valet_contract_variable_service !== null &&
      Object.keys(postCorData.valet_contract_variable_service).length > 0
    ) {
      setVariableServices(postCorData.valet_contract_variable_service);
    }

    if (
      postCorData?.valet_contract_fixed_service !== undefined &&
      postCorData?.valet_contract_fixed_service !== null &&
      Object.keys(postCorData.valet_contract_fixed_service).length > 0
    ) {
      setFixedServices(postCorData.valet_contract_fixed_service);
    }
  }, [postCorData]);

  // console.log('gg ', postCorData);
  function refreshPage() {
    window.location.reload(false);
  }

  // Unused: Select User UI that consumed getUserBasedDropdown is commented out.
  // useEffect(() => {
  //   (async () => {
  //     if(formStage === 1){
  //       await userRoleBasedDropdown();
  //     }
  //   })();
  // }, [userRoleBasedDropdown])

  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">
          {localization.save}
        </Button>
        <Button onClick={() => handleSubmit(params.lead_id)} disabled={isClicked}>
          {localization.submitDtl} <Image fluid src={Images?.ArrowRight} />
        </Button>
      </Fragment>
    );
  };

  const handleVariableService = (index, key, val) => {
    let list = [...variableServices]
    let isAlreadyExist = false
    if(list.length > 1 && key === 'id'){
      variableServices.map((vali, i) => {
        if(parseInt(vali?.id) === parseInt(val)){
          isAlreadyExist = true
        }
      })
    }

    if(isAlreadyExist){
      setTimeout(() => {
        list.splice(list.length-1, 1)
        setVariableServices(list)
        toast.warning("Service already selected.")
      }, 1000)
      return false
    }

    list[index][key] = val
    setVariableServices(list)
  }

  const handleFixedService = (index, key, val) => {
    let list = [...fixedServices]
    let isAlreadyExist = false
    if(list.length > 1 && key === 'id'){
      fixedServices.map((vali, i) => {
        if(parseInt(vali?.id) === parseInt(val)){
          isAlreadyExist = true
        }
      })
    }

    if(isAlreadyExist){
      setTimeout(() => {
        list.splice(list.length-1, 1)
        setFixedServices(list)
        toast.warning("Service already selected.")
      }, 1000)
      return false
    }

    list[index][key] = val
    setFixedServices(list)
  }
  const handleCommercialSubmit = () => {
     if(postCorporateData?.commercial === null || postCorporateData?.commercial === undefined) {
        setIsFiled(true);

        const active = document.querySelector('.activeAnkInput');
        // console.log(active);
        if(active){
          active.focus();
        }else{
          alert('Please Upload missed documents or enter valid data!');
        }
        return;
     }

     if (isEcom && postCorporateData && postCorporateData.commercial) {
      postCorporateData.commercial.subAmt = 1;
      postCorporateData.commercial.commercialType = 7;
    }

     const dataValue = postCorporateData?.commercial;
     //return false;
     var validate = true;
     if((dataValue?.commercialType === 7 || dataValue?.commercialType === 6) && (dataValue?.paymentTerms == "" || dataValue?.products == "" || dataValue?.paymentMode == "" || dataValue?.solution_type == "" || dataValue?.totalContract == "" || dataValue?.LockIn == "" || dataValue?.subAmt == "" || dataValue?.agreementContractPeriodTo == "" || dataValue?.agreementContractPeriodFrom == "" || dataValue?.agreementSigningDate == "" || dataValue?.contract_doc == "" || dataValue?.paymentDueDays == "" || dataValue?.salesType == "") && !isEcom) {
        validate = false;
     }
     if(dataValue?.leadType && dataValue?.leadType === 1 && dataValue?.commercialType === 5) {
        if((dataValue?.products == "" || dataValue?.paymentMode == "" || dataValue?.solution_type == "" || dataValue?.totalContract == "" || dataValue?.LockIn == "" || dataValue?.agreementContractPeriodTo == "" || dataValue?.agreementContractPeriodFrom == "" || dataValue?.agreementSigningDate == "" || dataValue?.contract_doc == "" || dataValue?.paymentDueDays == "" || dataValue?.salesType == "")) {
          validate = false;
        }
     } else {
        if(dataValue?.commercialType === 5 && (dataValue?.totalAmount == "" || dataValue?.products == "" || dataValue?.paymentMode == "" || dataValue?.solution_type == "" || dataValue?.totalContract == "" || dataValue?.LockIn == "" || dataValue?.agreementContractPeriodTo == "" || dataValue?.agreementContractPeriodFrom == "" || dataValue?.agreementSigningDate == "" || dataValue?.contract_doc == "" || dataValue?.paymentDueDays == "" || dataValue?.salesType == "")) {
          validate = false;
        }
    }
     if(!isEcom &&  dataValue?.salesType !== "Direct Sales") {
        if(dataValue?.channelPartner == "") {
          validate = false;
        }
        if(dataValue?.channelPartner == "Others" && dataValue?.channelPartnerValue == "") {
          validate = false; 
        }
     }
     if(dataValue?.leadType==2 && (dataValue?.builderType==''||dataValue?.builderType==null||dataValue?.builderType==undefined)){
          validate=false
     } 
     if(!isEcom && dataValue?.isPOAvailable==''){
          validate=false
     }
     if(dataValue?.isPOAvailable && dataValue?.isPOAvailable=='Yes'){
        if(dataValue?.pODate==null || dataValue?.pODate==''|| dataValue?.pONumber==null || dataValue?.pONumber=='' || dataValue?.pOUpload==null || dataValue?.pOUpload==''){
          validate=false
          toast.error('PO details are missing.')
          return false;
        }
     }
     //Validation check
     if(validate) {
        const comm_data = {
            'lead_id':match.params.lead_id,
            'comm_id':match.params.comm_id,
            'commercial':postCorporateData?.commercial
        };
        (async () => {
          const res = await postSalesCorporateLeadNew(comm_data);
          if (res) {
            setIsModal(true);
          }
        })();
     } else {

          setIsFiled(true);
          const active = document.querySelector('.activeAnkInput');
          // console.log(active);
          if(active){
            active.focus();
          }else{
            toast.error('Please Upload missed documents or enter valid data!')
          }
     }
     
  }

const handleSolutoionSubmit = () => {

  const {
    gateDetails,
    productInventory,
    materialHardwares,
    tagsData,
    selectedDocuments,
    softwareInventory
  } = postCorporateData;
  if(gateDetails != null && materialHardwares != null && materialHardwares != 'No'){
    var fObj = {
      gates:gateDetails
    };
    if (productInventory !== null && productInventory !== undefined) {
      fObj.hardware = [
        ...productInventory?.productData,
      ];
    } else {
      fObj.hardware = [];
    }
    if(materialHardwares.materialHardwareReq=='no'){
      if(!window.confirm('Are you sure to continue with no hardware requirement?')) {
        return false;
      }
      fObj.hardware = [];
    }
    if(softwareInventory !== null && softwareInventory !== undefined && softwareInventory?.softwareInventoryData?.length > 0){
      fObj.software = [
        ...softwareInventory?.softwareInventoryData,
      ];
    } else if (postSalesData?.software && postSalesData.software.length > 0) {
      // Fallback to postSalesData if softwareInventory is not yet set
      fObj.software = [
        ...postSalesData.software,
      ];
    } else {
      fObj.software = [];
    }
    if (tagsData !== null && tagsData !== undefined && tagsData?.tagData?.length>0) {
        const foundZeroPrice = tagsData.tagData.find(tag => parseInt(tag.unit_price) === 0);
      
        if (foundZeroPrice) {
            toast.error("Unit price cannot be zero for paid tags");
            return false; 
        }
        const foundZeroQuantity = tagsData.tagData.find(tag => parseInt(tag.quantity) === 0);
      
        if (foundZeroQuantity) {
            toast.error("Tag quantity cannot be zero");
            return false; 
        }
        fObj.tags = [
          ...tagsData?.tagData,
        ];
      } else {
        fObj.tags = [];
      }

    if(materialHardwares?.materialHardwareReq == 'yes'){
      if(fObj.hardware != null && fObj.hardware != undefined){
        let isNotEmpty = true;
        fObj.hardware.map((x, i) => { 
          if((parseInt(postCorData?.leadType) === 1 || parseInt(postCorData?.leadType) === 2) && parseInt(postCorData?.commercialData?.commercial_type_id) === 5) {
            if (x.category_id == '' || x.category_id == null || x.brand_id == '' || x.brand_id == null || x.material_id == '' || x.material_id == null || x.quantity == '' || x.quantity == null || x.quantity === 0 || x.quantity === "0") {
              isNotEmpty = false;
            }
          } else {
            if (x.category_id == '' || x.category_id == null || x.brand_id == '' || x.brand_id == null || x.material_id == '' || x.material_id == null || x.quantity == '' || x.quantity == null && x.quantity == 0) {
              isNotEmpty = false;
            }
          }  
        });
        if(isNotEmpty == false){
          setIsFiled(true);
          const active = document.querySelector('.activeAnkInput');
          if(active){
            active.focus();
          }else{
            alert('Please fill all details ')
          }
        }
       
        
      }else{
        setIsFiled(true);
        const active = document.querySelector('.activeAnkInput');
        if(active){
          active.focus();
        }else{
          alert('Please Upload missed documents or enter valid data!')
        }
      }
    }

    const active = document.querySelector('.activeAnkInput');
    if(active){
      active.focus();
    }else{
    // console.log(materialHardwares); return false;
       const comm_data = {
           'lead_id':match.params.lead_id,
           'comm_id':match.params.comm_id,
           'form_stage':4,
           'required_documents': selectedDocuments?.selectedDocuments,
           ...fObj
        };
        (async () => {
         const res = await postSolutionProduct(comm_data);
         if (res) {
           setIsModal(true);
         }
       })();
      }
  }else if (postCorData?.commercialData?.revenue_nature === 'Services' && materialHardwares === "No"){
    const comm_data = {
      lead_id: match.params.lead_id,
      comm_id: match.params.comm_id,
      form_stage: 4,
      ...fObj,
      fixedServices,
      variableServices
    };
    if((variableServices && variableServices.length > 0 && variableServices[0]?.id == '' && variableServices[0]?.amount == '' && variableServices[0]?.qty == '') && (fixedServices && fixedServices.length > 0 && fixedServices[0]?.id == '' && fixedServices[0]?.amount == '' && fixedServices[0]?.qty == '')) {
      toast.error("Please fill atleast 1 service");
      return false; 
    }

    if(!compareServicesAmtWSubscAmt()){
      toast.error("Services amount is not equal to total subscription amount");
      return false; 
    }
    // console.log("COMM_DATA: " + comm_data);
    // return false;
    (async () => {
      setIsLoading(true);
      const res = await postSolutionProduct(comm_data);
      if (res) {
        setIsModal(true);
        setIsLoading(false);
      }
      setIsLoading(false);
    })();
  }
  else{
    setIsFiled(true);
    const active = document.querySelector('.activeAnkInput');
    if(active){
      active.focus();
    }else{
      alert('Please Upload missed documents or enter valid data!!');
    }
  }


}
 const handleClientSubmit = () => {
  const checkValue = postCorporateData?.clientData;
  if(checkValue.gstNumber != '' && checkValue.gstNumber!=null){
    checkValue.isGstApplicable = "Yes";
  }
  if(checkValue.client_type = 'existing_client' && checkValue.client_billing_id == 'undefined' && checkValue.billing_address == 'undefined'){
    toast.error('Please fill Billing Address');
    return false;
  }
  var clientValidator = true;
  if(checkValue?.is_pan_selected==true && (checkValue?.panNumber === '' || checkValue?.panNumber === undefined || checkValue?.panNumber === null)){
    toast.error('PAN number is required!')
    return false;
  }
  if(postCorData?.is_pan_required == true && (checkValue?.panNumber === '' || checkValue?.panNumber === undefined || checkValue?.panNumber === null)){
    toast.error('PAN number is required!')
    return false;
  }
  if(checkValue.gstNumber && checkValue.gstNumber !== '' && checkValue.gstNumber !== null && Regex.gstRegex.test(checkValue.gstNumber) === false){
    toast.error('Invalid GST number. GSTIN must be 15 characters long and match the format: 11AAAAA1111A1Z1.');
    return false;
  }
  if(checkValue?.client_type === 'existing_client' && (checkValue?.client_id == "" || (checkValue?.client_billing_id == "" && checkValue?.billing_address == null))) {
    clientValidator = false;
  }
  if(checkValue.poc_data) {
    const poc = checkValue.poc_data
     if(poc.pocName == "" || poc.pocDesVal == "" || poc.number == "" || poc.email == "") {
      clientValidator = false;
     }
  }else if(checkValue.client_poc_id && checkValue.client_poc_id == ""){
    clientValidator = false;
  }

  if(checkValue.isGstApplicable && checkValue.isGstApplicable == "") {
    clientValidator = false;
  }
  // if(checkValue?.isGstApplicable == "Yes" && checkValue?.gstFile == "") {
  //   clientValidator = false;
  // }
  // if(checkValue?.isGstApplicable == "No" && checkValue?.nonGstFile == "") {
  //   clientValidator = false;
  // }
  // if(checkValue?.clientBrd == ""){
  //   clientValidator = false;
  // }
  if (checkValue.tan_number && !checkValue.tan_attachment) {
    toast.error('Please provide tan attachment too');
    return false;
  }
  if (checkValue.tan_number && checkValue.tan_number != checkValue.confirm_tan_number) {
    toast.error('Tan number and confirm tan number should be same');
    return false;
  }
  if (checkValue.tan_number && !tanRegex.test(checkValue.tan_number)) {
    toast.error('Invalid TAN number format');
    return false;
  }
  const clientPocData = checkValue.poc_data;

  const isPocDataValid =
    clientPocData &&
    (
      clientPocData.pocName ||
      clientPocData.number ||
      clientPocData.email
    );

  if (!checkValue.client_poc_id && !isPocDataValid) {
    toast.error("Please select a POC or enter POC details");
    return false;
  }

  if(checkValue?.client_type === 'new_client') {
    const billAddress = checkValue.billing_address; 
    if(!billAddress){
      clientValidator = false;
    }else{
      if(checkValue?.client_name == "" || billAddress?.billPinId == "" || billAddress?.billGeoCityId == "" || billAddress?.billGeoStateId == "" || billAddress?.billAddressLine1 == "") {
        clientValidator = false;
        checkValue.client_id=''
        checkValue.client_billing_id=''
        checkValue.client_billing_value=''
        checkValue.client_poc_id=''
        checkValue.client_poc_value=''
      }
    }   
  }
  if(checkValue?.client_billing_value === 'Other' && (!checkValue?.billing_address || Object.keys(checkValue?.billing_address).length === 0)){
    clientValidator = false;
  }

  if (
    (
      !checkValue?.client_billing_id ||
      !checkValue?.client_billing_value?.trim()
    ) &&
    !checkValue?.billing_address?.billPinId
  ) {
    clientValidator = false;
  }

  if(clientValidator) {
    const clientPayload = { ...postCorporateData?.clientData };
    if (
      clientPayload?.poc_data &&
      typeof clientPayload.poc_data === 'object' &&
      clientPayload.poc_data.pocName
    ) {
      clientPayload.client_poc_id = '';
      clientPayload.client_poc_value = '';
    }
    const client_data = {
      'lead_id':match.params.lead_id,
      'comm_id': match.params.comm_id,
      'client': clientPayload
    };
    (async () => {
      setIsLoading(true);
      const res = await postSalesClientData(client_data);
      if (res) {
        setIsModal(true);
        setIsLoading(false);
      }
    })();
  } else {
    setIsFiled(true);
    const active = document.querySelector('.activeAnkInput');
    if(active){
      active.focus();
    }else{
      toast.error('Please Upload missed documents or enter valid data!')
    }
  } 
}


 const handleAdvancePaySubmit = () => {
  // console.log('advance' , postCorporateData?.advPayment); return false;
  var advanceValidator = true;
  var amountError = false;
  const advData = postCorporateData?.advPayment;
  if(advData?.isAdv === 'Yes') {
    advData?.advData.map((value,index) => {
         if(value.payment_mode == "" || value.trans_amount == "" || value.reference_number == "" || value.tds_check == "" || value.adv_payment_date == "" || value.payment_photo == "") {
          advanceValidator = false;
          return false;
         }
         if(value.tds_check == 'Yes' && value.tds_amt == "") {
            advanceValidator = false;
            return false;
         }
         let amt = Number(value.installation_amt) + Number(value.cartage_amt) + Number(value.tag_charge) + Number(value.rental_charge) + Number(value.capex_charge);
        //  console.log(amt + ' - ' + value.trans_amount);
         
         if(Number(value.trans_amount) !== amt) {
             amountError = true;
             return false;
         }
    });
  }
  // return false;
  if(amountError) {
    toast.error("Transaction amount must be equal to advance amount");
    return false;
  }
  //return false;
  if(advanceValidator) {
      const adv_payment_data = {
        'lead_id':match.params.lead_id,
        'comm_id': match.params.comm_id,
        'advance':postCorporateData?.advPayment,
        'modification_status':0
      };
      (async () => {
        const res = await postSalesAdvancePayments(adv_payment_data);
        if (res) {
          setIsModal(true);
        }
      })();
  } else {
      setIsFiled(true);
      const active = document.querySelector('.activeAnkInput');
      if(active){
        active.focus();
      }else{
        toast.error('Please Upload missed documents or enter valid data!')
      }
  }
  
}


// handleInstallationSubmit
const handleInstallationSubmit = () => {
  // get the installation and poc data
  let {
    increamentData ,
    pocData
  } = postCorporateData;

  let increamentDatas = [];
  // check if solution type is services , then no need to send installation data
  // just add default installation type as No
  if(postCorData?.commercialData !== undefined && postCorData?.commercialData?.solution_type != 3){
    if(postCorporateData?.installation?.installationData){
      let inst = postCorporateData?.installation?.installationData;
      if((parseInt(postCorData?.leadType) === 1 || parseInt(postCorData?.leadType) === 2) && parseInt(postCorData?.commercialData?.commercial_type_id) === 5) {
        var allChecks = false;
        var consumbalesAmt = 0;
        if(inst?.consumables && inst?.consumables === 'Yes') {
          inst?.consumablesData.forEach(element => {
            // if(element.name == '') {
            //    toast.error('Consumable name is required');
            //    allChecks = true;
            //    return false;
            // }
            // if(element?.make == '') {
            //   toast.error('Make is required');
            //   allChecks = true;
            //   return false;
            // }  
            // if(parseInt(element?.scope) !== 1) {
              if(element.id == '' || element.id == null || element.id == undefined || element.id === 0) {
                toast.error('Consumable Item is required');
                allChecks = true;
                return false;
              }

               if(element.uom == '') {
                toast.error('Consumable UOM is required');
                allChecks = true;
                return false;
               }
              //  if(element.name === 'Others') {
              //     if(element.name_other == '' || element.name_other == null) {
              //       toast.error('Others field is required');
              //       allChecks = true;
              //       allChecks = true;
              //       return false;
              //     }
              //  }
               if(element.sales_qty == '') {
                toast.error('Consumable Quantity is required');
                allChecks = true;
                return false;
               }
               if(element.sale_unit_price == '') {
                toast.error('Consumable Sale Unit price is required');
                allChecks = true;
                return false;
               }
            // }
            consumbalesAmt = consumbalesAmt + (parseFloat(element.sale_unit_price) * parseFloat(element.sales_qty));
          });
        }else{
          inst.consumablesData = [];
        }
        if(allChecks) {
          return false;
        }
      } 
      if(parseFloat(inst?.installation_charge) > 0){
        if(consumbalesAmt > parseFloat(inst?.installation_charge)){
          toast.error('Consumables amount can not be greater then installation amount.');
          return false;
        }
      }
      // let isNotEmpty = true;
      if (inst.civil_scope == '' || inst.installation_start_date == '' || inst.installation_start_date == null || inst.installation_deadline == '' || inst.installation_deadline == null || inst.electric_scope == '') {
        // inst.tag_check=='' || inst.installation_check=='' || inst.rental_check==''
        // isNotEmpty = false;
        setIsFiled(true);
        const active = document.querySelector('.activeAnkInput');
        if(active){
          active.focus();
        }else{
          toast.error('Please Upload missed documents or enter valid data!')
        }
        return;
      }

      if(postCorData?.commercialData?.commercial_type_id !== 5){
        if (inst.tag_check=='' || inst.installation_check=='' || inst.rental_check=='') {
          // isNotEmpty = false;
          setIsFiled(true);
          const active = document.querySelector('.activeAnkInput');
          if(active){
            active.focus();
          }else{
            toast.error('Please Upload missed documents or enter valid data!')
          }
          return;
        }
      }
  
      if (increamentData !== null && increamentData !== undefined) {
          if (increamentData?.inc?.increament_type) {
            if (increamentData?.inc?.increament_type == 'flat' || increamentData?.inc?.increament_type == 'percentage') {
              if (increamentData?.inc?.duration == undefined || increamentData?.inc?.duration == '' || increamentData?.inc?.increament_amount == undefined ||  increamentData?.inc?.increament_amount == '') {
                toast.error("Please fill the increment Duration and amount")
                return false;
              }
            }
            increamentDatas = increamentData;
          }else{
            toast.error("Please Select increment type")
            return false;
          }
        }
      
    }else{
      toast.error('Please check form details');
    }
  }else{
    increamentDatas = {
      inc: {
        increament_type: 'no'
      }
    };
  }

  let pocCheck = 1;
  // pocData
  let contactNumber = [];
  let pocName = [];
  
  pocData.map((x, i) => {
    // const isNotEmpty = handleValidateObj(x);
    contactNumber.push(x.contact_number);
    pocName.push(x.poc_name);
    let checkCondition = parseInt(postCorData?.leadSubType) === 6 ? i < 1 : i!==2;
    if(checkCondition){
      if(x.poc_name == '' || x.poc_designation == '' || x.contact_number == ''){
        setIsFiled(true);
        const active = document.querySelector('.activeAnkInput');
        if(active){
          active.focus();
        }else{
          toast.error('Please fill all poc details')
        }
        pocCheck = 0;
        return false;
        
      }
    }
    if(parseInt(postCorData?.leadSubType) !== 6  && x.contact_number !== '' && x.contact_number !== undefined && x.contact_number.length!=10){
      toast.error('The POC contact number should be 10 digits')
      pocCheck=0;
      return false;
    }
    // pocCheck = 1;

  });
  if(pocCheck==0){
    return false;
  }
  const uniqueSet = new Set(contactNumber);

  if(parseInt(postCorData?.leadSubType) !== 6 && uniqueSet.size !== contactNumber.length){
    toast.error('POC contact number should be unique!')
    pocCheck =0;
  }

  const nameUniqueSet = new Set(pocName);

  if(parseInt(postCorData?.leadSubType) !== 6 && nameUniqueSet.size !== pocName.length){
    toast.error('POC Name should be unique!')
    pocCheck =0;
  }

  if(pocCheck){

    if(parseInt(postCorData?.leadSubType) === 6){
       pocData.splice(1, 2);
    }
    const installation = {
      'lead_id':match.params.lead_id,
      'comm_id': postCorData?.comm_id,
      'form_stage': postCorData?.commercialData?.solution_type == 3 ? 6 : 5,
      'installation':postCorporateData?.installation,
      'increamentDatas': increamentDatas,
      'solution_type': postCorData?.commercialData?.solution_type,
      'pocData' : pocData,
  };
    // return false;
    (async () => {
      const res = await postSalesInstallation(installation);
      if (res) {
        setIsModal(true);
      }
    })();
  }
}

const handleCapexInvoiceModuleAction = async (mode) => {
  const { capexInvoiceModule } = postCorporateData;

  // 🔹 Use common validator
  if (!invoiceValidator(capexInvoiceModule)) return;

  // Common payload
  const fObj = {
    ...capexInvoiceModule.invoice_module,
    invoices_items: capexInvoiceModule.line_items,
    retention: capexInvoiceModule.retention,
  };

  let capexInvoiceModuleData;
  if (mode === "submit") {
    capexInvoiceModuleData = {
      lead_id: match.params.lead_id,
      contract_id: postCorData?.comm_id,
      form_stage: 6,
      ...fObj,
    };
  } else {
    capexInvoiceModuleData = {
      lead_id: parseInt(match.params.lead_id),
      comm_id: parseInt(postCorData?.comm_id),
      capex_invoicing: fObj,
    };
  }

  try {
    if (mode === "submit") {
      const res = await postCapexInvoiceModule(capexInvoiceModuleData);
      if (res) setIsModal(true);
    } else {
      setIsLoading(true);
      const res = await contractInvoicePreview(capexInvoiceModuleData);
      setIsLoading(false);
      if (res) setCapexInvoiceLink(res?.data?.invoices_preview);
    }
  } catch (err) {
    toast.error("Something went wrong.");
  }
};

// Wrappers
const handleCapexInvoiceModuleSubmit = () => handleCapexInvoiceModuleAction("submit");

const handleCapexInvoiceModuleInvoicePreview = () => handleCapexInvoiceModuleAction("preview");

// handleMileStoneSubmit

const handleMileStoneSubmit = () => {
  const {
    milestone
  } = postCorporateData;

  var fObj = {};
  if (milestone !== null && milestone != undefined) {
    let totalAmt = (postSalesData?.commercial?.total_mg_amount && postSalesData?.commercial?.total_mg_amount !== undefined) ? postSalesData?.commercial?.total_mg_amount : parseInt(postCorData?.commercialData?.total_mg_amount);
    let calculatedAmt = 0;
    if (!isNaN(totalAmt)) {
      if (totalAmt > 0) {
        for (let i = 0; i < postCorporateData.milestone?.milestone_data.length; i++) {
          if (postCorporateData.milestone.milestone_data[i].amt) {
            if(postCorporateData.milestone.milestone_data[i].desc == '' || postCorporateData.milestone.milestone_data[i].desc == null || postCorporateData.milestone.milestone_data[i].desc == undefined){
              toast.error('Please fill the description');
              return;
            }
            calculatedAmt += parseInt(postCorporateData.milestone.milestone_data[i].amt);
          }
        }
        for (let i = 0; i < postCorporateData.milestone?.date_invoices_data.length; i++) {
          if (postCorporateData.milestone.date_invoices_data[i].amt) {
            if(postCorporateData.milestone.milestone_data[i].desc == '' || postCorporateData.milestone.milestone_data[i].desc == null || postCorporateData.milestone.milestone_data[i].desc == undefined){
              toast.error('Please fill the description');
              return;
            }
            calculatedAmt += parseInt(postCorporateData.milestone.date_invoices_data[i].amt);
          }
        }
        for (let i = 0; i < postCorporateData.milestone?.retention.length; i++) {
          if (postCorporateData.milestone.retention[i].amt) {
            if(postCorporateData.milestone.milestone_data[i].desc == '' || postCorporateData.milestone.milestone_data[i].desc == null || postCorporateData.milestone.milestone_data[i].desc == undefined){
              toast.error('Please fill the description');
              return;
            }
            calculatedAmt += parseInt(postCorporateData.milestone.retention[i].amt);
          }
        }

        if(calculatedAmt == 0){
          toast.error('Please Fill atleast one milestone');
          // alert('Please Fill atleast one milestone')
          return;
        }
        else if (calculatedAmt > totalAmt) {
          toast.error('Milestone total amount is greater then capex amount!');
          setIsClicked(false);
          setIsFiled(true);
          return;
        } 
        else if (calculatedAmt != totalAmt) {
          toast.error('Milestone total amount should be equal to capex amount!');
          setIsClicked(false);
          setIsFiled(true);
          return;
        }
        else {
          fObj.milestone=milestone;
        }
      }
    }
  }else{
    toast.error('Please enter atleast one data');
    return;
    
    
  }

  const installation = {
     'lead_id':match.params.lead_id,
     'comm_id': match.params.comm_id,
     'form_stage':6,
     ...fObj
  };
  (async () => {
   const res = await postSalesMileStone(installation);
   if (res) {
     setIsModal(true);
   }
 })();
}


// handleInvoiceSubmit
const handleInvoiceSubmit = () => {

  const {
    InvoiceModuleData
  } = postCorporateData;
  var fObj = {};
  if(InvoiceModuleData !== null && InvoiceModuleData != undefined){
    let subsAmt = Number(postCorData?.commercialData?.subscription_amount);
    let invoiceAmt = InvoiceModuleData?.invoiceAmt;
    const initialValue = 0;
    const sumWithInitial = invoiceAmt.reduce(
      (previousValue, currentValue) => previousValue + currentValue,
      initialValue
    );
    if(subsAmt === sumWithInitial ){
      fObj.InvoiceModuleData=InvoiceModuleData;
    }else{
      toast.error('Total amount of invoice module is not equal to the total subscription amount!');
      setIsClicked(false);
      setIsFiled(true);
      return;
    }
   

  }

  const installation = {
     'lead_id':match.params.lead_id,
     'comm_id': match.params.comm_id,
     'form_stage':6,
     ...fObj
  };
  (async () => {
   const res = await postSalesInvoiceModule(installation);
   if (res) {
     setIsModal(true);
   }
 })();
}

  /**
   * compareServicesAmtWSubscAmt
   */
  const compareServicesAmtWSubscAmt = () => {
    let totalServiceAmt = 0;
    let subsAmt = Number(postCorData?.commercialData?.subscription_amount);
    if(variableServices && variableServices.length > 0 && variableServices[0]?.id !== '' && variableServices[0]?.amount !== '' && variableServices[0]?.qty !== ''){
      for(let variableS of variableServices){
        totalServiceAmt += parseFloat(variableS['amount']) * parseInt(variableS['qty']);
      }
    }
    if(fixedServices && fixedServices.length > 0 && fixedServices[0]?.id !== '' && fixedServices[0]?.amount !== '' && fixedServices[0]?.qty !== ''){
      for(let fixedS of fixedServices){
        totalServiceAmt += parseFloat(fixedS['amount']) * parseInt(fixedS['qty']);
      }
    }
    if(parseInt(totalServiceAmt) === parseInt(subsAmt)){
      return true;
    }
    return false;
  }


  //New Gate and material invendtory handling
  useEffect(() => {
    if(postCorporateData && postCorporateData?.gateDetails && postCorporateData?.gateDetails?.length > 0 && inventoryEditable == true) {
      const currentData = postCorporateData?.gateDetails;
      const currentSetupIds = currentData.map(item => item.current_setup_id);
      if(postCorporateData?.materialHardwares?.materialHardwareReq && postCorporateData?.materialHardwares?.materialHardwareReq === 'yes') {
        (async () => {
          // setIsLoading(true)
          const res = await getInventoryMasterData(postCorporateDetails?.leadSubType,currentSetupIds);
          if(res) {
            setInventoryMasterData(res);
          }
          // setIsLoading(false)
        })();
      }
    }
  },[postCorporateData?.gateDetails, postCorporateData?.materialHardwares]);
  useEffect(() => {
      if(inventoryData && inventoryData !== undefined && inventoryData !== null) {
        setInventoryMasterData(inventoryData);
      }
  },[inventoryData]);
  // End


  // 
  return (
    <Layout
      history={history}
      // Buttons={handleButtons}
      isGoback
      className={isFiled ? 'requiredFileds' : ''}
      title={localization.addContractForBusiness + projectName}
      isLoading={isLoading}
    >
    <div className="container-v2">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.0.3/css/font-awesome.css" />
        <div id="msform">
                          
          <ul id="progressbar">
              {/* <li className="active" id="account"><strong>Account</strong></li>
              <li id="personal"><strong>Personal</strong></li>
              <li id="payment"><strong>Payment</strong></li>
              <li id="confirm"><strong>Finish</strong></li> */}
              <li id="confirm" class={`${(formStage < 2) ? 'active' : 'done'}`}><span className='pb-v2'><strong>Commercial Details</strong></span></li>
              <li id="confirm" class={`${(formStage == 2) ? 'active' : (formStage > 2) ? 'done' :  'inactive'}`}><span className='pb-v2'><strong>Client Details</strong></span></li>
              <li id="confirm" class={`${(formStage == 3) ? 'active' : (formStage > 3) ? 'done' :  'inactive'}`}><span className='pb-v2'><strong>Solutions and Product</strong></span></li>
              <li id="confirm" class={`${(formStage == 4) ? 'active' : (formStage > 4) ? 'done' :  'inactive'}`}><span className='pb-v2'><strong>{postCorData?.commercialData?.solution_type !== 3 ? `Installation Details` : `POC Details`}</strong></span></li>
              {postCorData?.commercialData?.solution_type !== 3 && (
                <li id="confirm" class={`${(formStage == 5) ? 'active' : (formStage > 5) ? 'done' :  'inactive'}`}><span className='pb-v2'><strong>Invoicing Details</strong></span></li>
              )}
              <li id="confirm" class={`${(formStage == 6) ? 'active' : (formStage > 6) ? 'done' :  'inactive'}`}><span className='pb-v2'><strong>Advance Payments</strong></span></li>
          </ul>
        
          
      </div>
      {/* <ul className="progressbar">
        <li class={`${(formStage < 2) ? 'active' : 'done'}`}><span className='pb-v2'>Commercial Details</span></li>
        <li class={`${(formStage == 2) ? 'active' : (formStage > 2) ? 'done' :  'inactive'}`}><span className='pb-v2'>Client Details</span></li>
        <li class={`${(formStage == 3) ? 'active' : (formStage > 3) ? 'done' :  'inactive'}`}><span className='pb-v2'>Solutions and Product</span></li>
        <li class={`${(formStage == 4) ? 'active' : (formStage > 4) ? 'done' :  'inactive'}`}><span className='pb-v2'>Invoicing Milestones</span></li>
        <li class={`${(formStage == 5) ? 'active' : (formStage > 5) ? 'done' :  'inactive'}`}><span className='pb-v2'>Installation Details</span></li>
        <li class={`${(formStage == 6) ? 'active' : (formStage > 6) ? 'done' :  'inactive'}`}><span className='pb-v2'>Advance Payments</span></li>
      </ul> */}
    </div>

      {/* {postCorData.leadStatus <= 4 && ( */}
        <>
          {/* <B2BRevenue
              RevenueData={contractRevenueDetails}
              handleValue={handleRevenueDetails}
          /> */}


      {formStage === 1 &&  
        <>   
        <CommercialNew
          is_fastag={1}
          data={postCorData}
          handleValue={handleCommercial}
          documentUploadUrl={documentUploadUrl}
          documentUrlData={documentUrlData}
          supplyNameFun={supplyNameFun}
          splNameData={splNameData}
          handleCommercialSubmit={handleCommercialSubmit}
          prefilledData={postSalesData}
          userRoleBasedDropdown={userRoleBasedDropdown}
          getUserBasedDropdown={getUserBasedDropdown}
          saveExternalUserData={saveExternalUserData}
          insertExternalUser={insertExternalUser}
          setIsLoading={setIsLoading}
          leadId={match?.params?.lead_id}
          isEcom={isEcom}
        />
        {/* <AgreementContractNew
          handleValue={handleagreementDtls}
          documentUploadUrl={documentUploadUrl}
          agreementLength={agreementLength}
          showDetails={showAgreementDetails}
        /> */}
        </>
      }
      {/* <GSTDetails
        handleValue={handleGstDetails}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
      /> */}
       {/* <BilledTo
        handleValue={handleBillTo}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
      />

      <Checkbox
        label={'Same shipping address'}
        type="checkbox"
        errorMsg={localization.isRequired}
        onChange={(val) => {
          if (val) {
            setSameAsBillTo(postCorporateData.billedTo);
          } else {
            setSameAsBillTo({
              billPinCode: '',
              billGeoCity: '',
              billGeoState: '',
              billGeoCityId: '',
              billGeoStateId: '',
              billPinId: '',
              billAddressLine1: '',
              billAddressLine2: '',
            });
          }
        }}
      /> */}
      {/* <ShippedTo
        handleValue={handleShippedTo}
        locationPinCode={shipTolocationPinCode}
        pincodeData={shipToPincodeData}
        leadData={postCorData.lead_name}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        // sameAsBillTo={sameAsBillTo}
      /> */}
      
      {/*<AddPoc
        handleValue={handlePocData}
      />*/}
      {/* <ParkingRules handleValue={handleParkingRules} data={postCorData} /> */}
      </>
      {/* )} */}
      {/* postCorData.leadStatus */}
      {/* {console.log(postSalesData)} */}

      {postCorData.leadStatus === 9 && (
        <>
        {formStage === 2 && 
        <>
        <ClientAddressDetailsV2
          handleValue={handleClientData}
          locationPinCode={locationPinCode}
          pincodeData={pincodeData}
          data={postCorData}
          clientBillingAddress={clientBillingAddress}
          clientBillingPocData={clientBillingPocData}
          documentUploadUrl={documentUploadUrl}
          documentUrlData={documentUrlData}
          handleClientSubmit={handleClientSubmit}
          postSalesData={postSalesData}
          setIsLoading={setIsLoading}
          documentUploadUrlPublic={documentUploadUrlPublic}
          documentUrlDataPublic={documentUrlDataPublic}
        /> 
        <button onClick={handleGoBack} style={{'margin-top':'-43px'}} className="btn btn-sm btn-primary mb-4">
          {'Go Back'}
          </button>
        </>
      }
{formStage === 3 && (
            <>
              {postCorData?.commercialData?.revenue_nature !== "Services" && <GateDetailsNew
                handleValue={handleGateDtl}
                data={postCorData}
                imageUploadUrl={imageUploadUrl}
                videoUploadUrl={videoUploadUrl}
                prefilledData={postSalesData}
                inventoryEditable = {inventoryEditable}
                setInventoryEditable={setInventoryEditable}
              />}
              {postCorData?.commercialData !== undefined &&
                (postCorData?.commercialData?.revenue_nature !== "Valet" &&
                postCorData?.commercialData?.revenue_nature !== "Services") && (
                  <>
                    <MaterialHardware
                      handleValue={handleMaterialhardware}
                      data={postCorData}
                      handleGatesData={handleGatesData}
                      handleProductData={handleProductData}
                      getMaterial={getMaterial}
                      getBrandById={getBrandById}
                      getBrand={getBrand}
                      getMateriaById={getMateriaById}
                      postSalesData={postSalesData}
                      commData={postCorporateDetails}
                      requiredDocumentsDropdown={requiredDocumentsDropdown}
                      handleRequiredValues={handleRequiredValues}
                      inventoryMaster={inventoryMasterData}
                      solutionType = {postCorData?.commercialData?.solution_type}
                      inventoryEditable = {inventoryEditable}
                      handleSoftwareInventory={handleSoftwareInventory}
                    />
                    <Tags handleValue={handleTags} data={postCorData} postSalesData={postSalesData}/>
                    <div className="mt-2"></div>
                  </>
              )}
              {postCorData?.commercialData !== undefined &&
                (postCorData?.commercialData?.revenue_nature === "Valet" ||
                postCorData?.commercialData?.revenue_nature === "Services") && (
                  <ContractServices
                    serviceDetails={contractCatService}
                    setVariableServices={setVariableServices}
                    variableServices={variableServices}
                    handleVariableService={handleVariableService}
                    handleFixedService={handleFixedService}
                    handleValue={handleRevenueDetails}
                    setFixedServices={setFixedServices}
                    fixedServices={fixedServices}
                    revenueNature = {revenueNature}
                    managementFeeApplicable = {managementFeeApplicable}
                    commercialData={postCorData?.commercialData}
                  />
              )}
              <div className="row mb-4">
                <div className="col text-left">
                  <button onClick={handleGoBack} className="btn btn-sm btn-primary">
                    Go Back
                  </button>
                </div>

                <div className="col text-right">
                  <button
                    onClick={() => handleSolutoionSubmit()}
                    className="btn btn-theme btn-sm"
                    disabled={disabled}
                  >
                    Save & Next
                  </button>
                </div>
              </div>
              {/* <div className="col-md-12 text-right mt-3">
                <button
                  onClick={() => handleSolutoionSubmit()}
                  className="btn btn-theme mb-2 btn-sm"
                >
                  Save & Next
                </button>
              </div> */}
            </>
          )}

    {postCorData?.commercialData !== undefined && postCorData?.commercialData?.revenue_nature !== 'Valet' && formStage === 4 &&
        <>
        {
          postCorData?.commercialData?.solution_type !== 3 &&
          <>
            <Installation
            handleValue={handleInstallation}
            isApartment={true}
            prefilledData={postSalesData}
            commData={postCorporateDetails}
            postCorData={postCorData}
          />
          {postCorData?.commercialData !== undefined && postCorData?.commercialData?.revenue_nature !== 'Valet' && (postCorData.commercialData?.commercial_type_id === 7 || postCorData.commercialData?.commercial_type_id === 6) &&
           <>
           <Increament
                handleValue={handleIncreament}
                data={postCorData}
                imageUploadUrl={imageUploadUrl}
                // postSalesData={postSalesData}
                prefilledData={postSalesData.commercial}
              />
              
            </>
          }
          </>
        }
          <ThreePOC
                handleValue={handleThreePoc}
                data={postCorData}
                imageUploadUrl={imageUploadUrl}
                oldPocData={postSalesData.lead_pocs}
              />
          <div className='mt-2'></div>
          <div className="row mb-4">
            <div className="col text-left">
            <button onClick={handleGoBack} className="btn btn-sm btn-primary mb-4">
                {'Go Back'}
              </button>
            </div>

            <div className="col text-right">
            <button onClick={() => handleInstallationSubmit()} className='btn btn-theme mb-2 btn-sm' disabled={disabled}>
                Save & Next
              </button>
            </div>
          </div>
          
        
          <div className='mb-20'></div>
        </>
      }

    {formStage === 6 && 
     <>
     <AdvancePaymentNew
        handleValue={handlePayment}
        data={postCorData}
        imageUploadUrl={imageUploadUrl}
        handleAdvancePaySubmit={handleAdvancePaySubmit}
        prefilledData={postSalesData}
      />
      <button onClick={handleGoBack} style={{'margin-top':'-43px'}} className="btn btn-sm btn-primary mb-4">
          {'Go Back'}
          </button>
     </>
    }
{formStage === 5 && 
  <>
    {(postCorData.commercialData?.commercial_type_id === 7 || postCorData.commercialData?.commercial_type_id === 6) && (
      <>
      {/* {console.log(postSalesData)} */}
        <InvoiceModule
          handleValue={handleInvoiceAmt}
          data={postCorData} 
          prefilledData={postSalesData}
          invoiceAmtData={postSalesData}
        />
        <div className='mt-1'></div>
        <div className="row mb-4">
            <div className="col text-left">
            <button onClick={handleGoBack} className="btn btn-sm btn-primary mb-4">
                {'Go Back'}
              </button>
            </div>

            <div className="col text-right">
            <button onClick={() => handleInvoiceSubmit()} className='btn btn-theme mb-2 btn-sm' disabled={disabled}>
                Save & Next
              </button>
            </div>
          </div>
          </>
      )}
      {/* {console.log(handleMileStone)}
      {console.log(postCorData.commercialData)}
      {console.log(postCorData.solution)} */}
      {/* {console.log(postCorporateData?.gateDetails)} */}
      {/* {console.log(setIsGateDetailsChanged)} 
      {console.log(isGateDetailsChanged)} */}
      {postCorData.commercialData?.commercial_type_id === 5 && (
        <>
        
          {/* <Milestone
            handleValue={handleMileStone}
            totalAmount={postCorData.commercialData}
            mileStoneData={postCorData.solution}
            gateData={postSalesData?.gates_data}
            gateDetailsChanged = {setIsGateDetailsChanged} 
            isGateDetailsChanged = {isGateDetailsChanged} 
            prefilledData={postSalesData}
          /> */}
          <InvoiceModuleCapex
            handleValue={handleCapexInvoiceModule}
            totalAmount={postCorData.commercialData}
            gateData={postSalesData?.gates_data} 
            prefilledData={postSalesData}
            handleInvoicePreview={handleCapexInvoiceModuleInvoicePreview}
            capexInvoiceLink={capexInvoiceLink} 
            solutionStages={postCorData.solution}
          />
          <div className='mt-1'></div>
          <div className="row mb-4">
            <div className="col text-left">
            <button onClick={handleGoBack} className="btn btn-sm btn-primary mb-4">
                {'Go Back'}
              </button>
            </div>

            <div className="col text-right">
            <button onClick={() => handleCapexInvoiceModuleSubmit()} className='btn btn-theme mb-2 btn-sm' disabled={disabled}>
                Save & Next
              </button>
            </div>
          </div>
          </>
          
      )}
      
      </>
    }


       {/* <GateDetails
        handleValue={handleGateDtl}
        data={postCorData}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
      />
      
      {postCorData?.commercialData !== undefined && postCorData?.commercialData?.revenue_nature !== 'Valet' &&
          <MaterialHardware
              handleValue={handleMaterialhardware}
              data={postCorData}
              handleGatesData={handleGatesData}
              handleProductData={handleProductData}
              getMaterial={getMaterial}
              getMateriaById={getMateriaById}
          />
      }
          {postCorData?.commercialData !== undefined && postCorData?.commercialData?.revenue_nature === 'Valet' &&
              <ContractServices
                  serviceDetails={contractCatService}
                  setVariableServices={setVariableServices}
                  variableServices={variableServices}
                  handleVariableService={handleVariableService}
                  handleFixedService={handleFixedService}
                  handleValue={handleRevenueDetails}
                  setFixedServices={setFixedServices}
                  fixedServices={fixedServices}
                  commercialData={postCorData?.commercialData}
              />
          }

      {postCorData?.commercialData !== undefined && postCorData?.commercialData?.revenue_nature !== 'Valet' &&
          <Tags
            handleValue={handleTags}
            data={postCorData}

          />
      }

      {postCorData?.commercialData !== undefined && postCorData?.commercialData?.revenue_nature !== 'Valet' &&
          <Installation
            handleValue={handleInstallation}
            isApartment={true}
          />
      }

    <AdvancePayment
        handleValue={handlePayment}
        data={postCorData}
        imageUploadUrl={imageUploadUrl}
      />

      {postCorData?.commercialData !== undefined && postCorData?.commercialData?.revenue_nature !== 'Valet' &&
        <Increament
            handleValue={handleIncreament}
            data={postCorData}
            imageUploadUrl={imageUploadUrl}
          />
      } */}
     
      </>
      )}
{postCorData.leadStatus <= 4 && (
  // postCorData.leadId
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        closeButton={false}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>Contract details successfully submitted.</h5>
          <button onClick={refreshPage} className="btn btn-primary mb-4">
          {localization.saveAndNext} <img src={Images?.ArrowRight} alt="" />
          </button>
        </div>
      </ModalPop>
)}

{postCorData.leadStatus > 4 && (
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
        closeButton={false}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>Contract details successfully submitted.</h5>


          
          {((formStage === 6 || (formStage === 2 && postCorData?.commercialData?.solution_type === 99)) ? 
           <Link
           to={`${baseUrl}/postSalesListing`}
           className="btn btn-primary mb-4"
         >
           {localization.postSales} <img src={Images?.ArrowRight} alt="" />
         </Link>
          : 
          <button onClick={refreshPage} className="btn btn-primary mb-4">
          {localization.saveAndNext} <img src={Images?.ArrowRight} alt="" />
          </button>
          
          )}
         
        </div>
      </ModalPop>
)}

    </Layout>
  );
};

PostSalesCorporateV2Edit.propTypes = {
  history: propTypes.any,
  postCorporate: propTypes.func,
};

export default PostSalesCorporateV2Edit;